import { CloudOff } from 'lucide-react';
import { fmtTime } from '@siva/shared';
import { t } from '../i18n/index.js';

/**
 * "This is what we last knew, and when." Shown whenever a screen is rendering remembered figures
 * because the server could not be reached — never as an error, because nothing has gone wrong:
 * the worker is signed in, the phone simply has no signal. Punching is blocked separately, by the
 * punch button's own rules, so this never has to warn anyone off.
 */
export function OfflineNote({ at, onRetry }: { at: string | null; onRetry?: () => void }) {
  return (
    <div className="offline-note" role="status">
      <CloudOff size={18} aria-hidden="true" />
      <span>
        <strong>{t('offline_title')}</strong>
        <br />
        {at ? t('offline_as_of', { time: fmtTime(at) }) : t('offline_no_data')}
      </span>
      {onRetry && (
        <button type="button" className="small secondary" onClick={onRetry}>
          {t('try_again')}
        </button>
      )}
    </div>
  );
}
